import React from 'react';
import PropTypes from 'prop-types';
import SearchProduct from './components/search-product';
import * as S from './styles';

const ProductFinder = ({ onSelect, focusOnMount }) => (
  <S.ProductFinder>
    <SearchProduct
      onSelect={onSelect}
      focusOnMount={focusOnMount}
      showFloatingResult
    />
  </S.ProductFinder>
);

ProductFinder.propTypes = {
  onSelect: PropTypes.func,
  focusOnMount: PropTypes.bool,
};

ProductFinder.defaultProps = {
  onSelect: () => {},
  focusOnMount: false,
};

export default ProductFinder;

export { SearchProduct };
